import api from "@/services/api";
import { anchorPayload, anchorQueryParams } from "@/components/voice_ai/anchors";
// api.js is untyped JS, so its axios instance carries getPrefixedMethods without a declaration.
const prefixed = api;
const methods = prefixed.getPrefixedMethods("benefits-verification");
export const benefitsVerificationService = {
    list(anchor) {
        return methods.get("", { params: anchorQueryParams(anchor) });
    },
    listByOrders(orderKeys) {
        return methods.get("", { params: { order_info_ids: orderKeys.join(",") } });
    },
    create(anchor, input) {
        return methods.post("", { ...anchorPayload(anchor), ...input });
    },
    update(id, input) {
        return methods.patch(`${id}`, input);
    },
    confirm(id) {
        return methods.post(`${id}/confirm`);
    },
};
